export default "__VITE_ASSET__CYLM8XDS__"